import axios from "axios";
import type { AxiosResponse } from "axios";

import { ErrorNumberEnum } from "@/enum/request";
import { clearToken } from "@/lib/apiUtils";
import { routerUtils } from "@/lib/routerUtils";
import { clearBonusCenterStore } from "@/stores/bonusCenterStore";
import { clearUserStore } from "@/stores/userStore";

export interface CustomAxiosResponse<T = unknown> extends AxiosResponse<T> {
  data: T & { _param?: T; _errno?: number };
}

const server = axios.create({
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
  // 禁用预检请求
  withCredentials: false,
});

server.interceptors.request.use(
  async (config) => {
    // 如果是 OPTIONS 请求，直接拒绝
    if (config.method?.toLowerCase() === "options") {
      return Promise.reject(new Error("OPTIONS request cancelled"));
    }

    const baseUrl = config.url || "";
    const url = new URL(baseUrl);
    config.url = url.toString();
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

server.interceptors.response.use(
  <T>(response: CustomAxiosResponse<T>) => {
    if (response.data._errno) {
      // 直接拒绝 Promise，让错误处理进入 catch 块
      return Promise.reject(response.data);
    }
    response.data = response.data._param || response.data;
    return response;
  },
  (error) => {
    if (error.response) {
      console.error("Error Response:", error.response.data);
      if (
        error.response.status === ErrorNumberEnum.TokenError ||
        error.response.status === ErrorNumberEnum.TokenErrorDel
      ) {
        clearToken();
        clearUserStore();
        clearBonusCenterStore();
        routerUtils.push("/login");
      }
    } else if (error.request) {
      console.error("No Response:", error.request);
    } else {
      // 其他错误
      console.error("Error", error.message);
    }
    return Promise.reject(error);
  },
);

export default server;
